export default __webpack_public_path__ + "static/media/top-bottom.e561f594.png";